<template>
  <div></div>
</template>

<script>
  export default {
    props: [ 'transform', 'readonly' ]
  }
</script>
